export default {
    hickory : {
        slug : "hickory",
        name : "<span class='colored'>H</span>ickory",
        icon : require("@/assets/products/Hickory/Hickory.png"),
        heroImg : require("@/assets/products/Hickory/Hickory PPP V3.png"),
        gallery : [
            require("@/assets/products/Hickory/Hickory 960x1080.png"),
            require("@/assets/products/Hickory/Hickory V1 960x540.png"),
            require("@/assets/products/Hickory/Hickory V3 960x540.png"),
            { fr : require("@/assets/products/Hickory/KITANCESS+KITANCSMIS FR.png"), en : require("@/assets/products/Hickory/KITANCESS+KITANCSMIS EN.png") },
            require("@/assets/products/Hickory/Hickory Radio2.png")
        ],
        video : null,
        usAvailable : false,
        range : "PS"
    },
    cypress : {
        slug : "cypress",
        name : "<span class='colored'>C</span>ypress",
        icon : require("@/assets/products/cypress2.png"),
        heroImg : require("@/assets/products/Cypress/Cypress 960x1080 v3.png"),
        gallery : [
            require("@/assets/products/Cypress/Cypress 960x1080 v2.png"),
            require("@/assets/products/Cypress/Cypress V4 960x540.png"),
            require("@/assets/products/Cypress/Cypress 1440x480 v2.png"),
            { fr : require("@/assets/products/Cypress/KITANCESS+KITANCSMIS FR.png"), en : require("@/assets/products/Cypress/KITANCESS+KITANCSMIS EN.png") },
            require("@/assets/products/Cypress/Cypress 480x480 v2.png")
        ],
        video : "https://youtu.be/3TnxDqopsZE",
        usAvailable : true,
        range : "PS"
    },
    oak : {
        slug : "oak",
        name : "<span class='colored'>O</span>ak",
        icon : require("@/assets/products/oak.png"),
        heroImg : require("@/assets/products/Oak/OAK PPP v3.png"),
        gallery : [
            require("@/assets/products/Oak/Oak V2 960x1080.png"),
            require("@/assets/products/Oak/Oak V3 960x540.png"),
            require("@/assets/products/Oak/Radio oak.jpg"),
            { fr : require("@/assets/products/Oak/KITANCESS+KITANCSMIS FR.png"), en : require("@/assets/products/Oak/KITANCESS+KITANCSMIS EN.png") },
            require("@/assets/products/Oak/Oak V2 960x540.png")
        ],
        video : "https://youtu.be/9eobXV5fzaI",
        usAvailable : true,
        range : "PS"
    },
    cement : {
        slug : "cement",
        name : null,
        icon : require("@/assets/products/cement.png"),
        heroImg : require("@/assets/products/Cement/PPP Cement.png"),
        gallery : [
            require("@/assets/products/Cement/Cement 960x1080.png"),
            require("@/assets/products/Cement/960x540 Cement 3.png"),
            require("@/assets/products/Cement/960x540 Site.png"),
            require("@/assets/products/Cement/1440x480 Site.png"),
            require("@/assets/products/Cement/Cement 480x480.jpg")
        ],
        video : null,
        usAvailable : true,
        range : "PS"
    },
    sycamore : {
        slug : "sycamore",
        name : "<span class='colored'>S</span>ycamore",
        icon : require("@/assets/products/sycamore.png"),
        heroImg : require("@/assets/products/Sycamore/Sycamore PPP v3.png"),
        gallery : [
            require("@/assets/products/Sycamore/Sycamore 960x1080 v2.png"),
            require("@/assets/products/Sycamore/Sycamore V1 960x540.png"),
            require("@/assets/products/Sycamore/Sycamore V2 960x540.png"),
            require("@/assets/products/Sycamore/Sycamore 1215x500 v2.png"),
            require("@/assets/products/Sycamore/Sycamore 480x480 v2.png")
        ],
        video : null,
        usAvailable : false,
        range : "VA"
    },
    kypho : {
        slug : "kypho",
        name : null,
        icon : require("@/assets/products/ballon.png"),
        heroImg : require("@/assets/products/Kypho/Kypho PPP.png"),
        gallery : [
            require("@/assets/products/Kypho/Kypho 960x1080.png"),
            require("@/assets/products/Kypho/Kypho V1 960x540.png"),
            require("@/assets/products/Kypho/Kypho V2 960x540.png"),
            require("@/assets/products/Kypho/1440x480 kypho.png"),
            require("@/assets/products/Kypho/kypho 480x480.jpg")
        ],
        video : "https://youtu.be/nkczODf5vFg",
        usAvailable : true,
        range : "VA"
    },
    cage : {
        slug : "cedar-elm",
        name : "<span class='colored'>C</span>edar & <span class='colored'>E</span>lm",
        heroImg : require("@/assets/products/Cedar & Elm/Cedar & Elm PPP.png"),
        gallery : [
            require("@/assets/products/Cedar & Elm/Cedar&Elm 960x1080.png"),
            require("@/assets/products/Cedar & Elm/Cedar & Elm V1 960x540.png"),
            require("@/assets/products/Cedar & Elm/Cedar & Elm 9600x540.png"),
            require("@/assets/products/Cedar & Elm/KIT LC .jpg"),
            require("@/assets/products/Cedar & Elm/Cedar&Elm 1440x480.png")
        ],
        video : "https://youtu.be/ZB0GUEScHb4",
        usAvailable : true,
        range : "LC"
    },
    walnut : {
        slug : "walnut",
        name : "<span class='colored'>W</span>alnut",
        heroImg : require("@/assets/products/Walnut/Walnut PPP v2.png"),
        gallery : [
            require("@/assets/products/Walnut/Walnut 960x1080.png"),
            require("@/assets/products/Walnut/Walnut 1440x480 v2.png"),
            require("@/assets/products/Walnut/Walnut V1 960x540.png"),
            require("@/assets/products/Walnut/KIT CC 2 .jpg"),
            require("@/assets/products/Walnut/Walnut 480x480 v2.png")
        ],
        video : null,
        usAvailable : true,
        range : "CC"
    }
}
